// Vanilla filter for the GM encounter administration table.

function applyGmEncounterListFilter(): void {
  const input = document.getElementById('input_gm_encounter_list_filter') as HTMLInputElement | null;
  if (!input) return;
  const query = input.value.toLowerCase().trim();
  document.querySelectorAll<HTMLElement>('table.gm-encounter-list-table tbody tr.gm-encounter-list-main-row')
    .forEach((row) => {
      const child = row.nextElementSibling instanceof HTMLElement ? row.nextElementSibling : null;
      const hasChild = child?.classList.contains('tablesorter-childRow') === true;
      const searchable = `${row.textContent || ''}${hasChild ? ` ${child?.textContent || ''}` : ''}`.toLowerCase();
      const show = !query || searchable.includes(query);
      row.style.display = show ? '' : 'none';
      if (hasChild && child) child.style.display = show ? '' : 'none';
    });
}

document.addEventListener('input', (event) => {
  if (event.target instanceof HTMLElement && event.target.id === 'input_gm_encounter_list_filter') {
    applyGmEncounterListFilter();
  }
});

export {};
